import {get, post} from '../../utils/ApiUtil';
import PostalCode from '../../models/PostalCode';
import Page from '../../filters/Page';

/**
 * Get paginated list of postal codes
 *
 * @param filter
 * @returns {Promise<Page>}
 */
export async function getPaginatedPostalCodes(filter) {
  const data = await get('/api/admin/postal-codes/paginated', filter);
  return new Page(data, PostalCode);
}

/**
 * Import postal codes from CSV file
 *
 * @param file
 * @returns {Promise<*>}
 */
export async function importPostalCodes(file) {
  const formData = new FormData();
  formData.append('file', file);

  // Don't set Content-Type header - browser will set it automatically with boundary
  const data = await post('/api/admin/postal-codes/import', formData);
  return data;
}
